import React, { createRef } from 'react';
import ReactDOM from 'react-dom';
import NESAHeader from '../Inc/NESAHeader';
import NESAFooter from '../Inc/NESAFooter';
import './style.css';
import * as actions from '../../actions/index';
import warningAlert from './warning-alert.png'
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import InputMask from 'react-input-mask'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { history } from '../../container/History';
import Iframe from '../HOC/iframe'
import moment from 'moment'
import base64 from 'base-64'
import MembershipAlumniInfo from '../Inc/MembershipAlumniInfo'
import { CheckCircleTwoTone } from '@ant-design/icons';
import { Steps, Button, Tooltip, Spin, Row, Typography, Table, DatePicker, Switch, Col, Card, Modal, Form, Input, Radio, Checkbox, Select, Icon, Divider } from 'antd';


const FormItem = Form.Item;
const Step = Steps.Step;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const { Column, ColumnGroup } = Table;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const CHASE_URL = process.env.REACT_APP_CHASE
const PENDING_MEMBERSHIP_TEXT = process.env.REACT_APP_PENDING_MEMBERSHIP_TEXT;
const CONFIRM_MEMBERSHIP_TEXT = process.env.REACT_APP_CONFIRM_MEMBERSHIP_TEXT;
const { Text } = Typography;

const dataSource = [{ "firstName": "Dakota", "middleName": "Lane", "lastName": "Porubsky", "memberId": 119319322, "gender": "M", "phone": "2541111111", "email": "qa@scouting.org", "personGuid": "D69E0D3F-208C-4A6C-9AB4-E48355D820C9", "ethnicity": null, "address1": "1325 W Walnut Hill Ln.", "city": "Temple", "state": "TX", "zipCode": "76501", "country": "USA", "countryShort": "US", "countryId": 616, "awardingCouncilName": "Longhorn Council 662", "unitType": "Troop", "unitNumber": "0101", "eagleCity": "Temple", "eagleState": "TX", "eagleTroopNumber": "0101", "eagleBoardReviewDate": "2018-05-13", "eagleCertificationDate": "2018-07-23", "ineligibleFlag": false }]

let BackBtn = false

const summaryColumns = [
    {
        title: 'Name',
        dataIndex: 'firstName',
        key: 'firstName',
        render: (text, record) => (
            <span>{record.firstName} , {record.lastName}</span>
        )
    },
    {
        title: 'Level',
        dataIndex: 'level',
        key: 'level',
        render: (text, record) => (
            <span>5 Year</span>
        )
    },
    {
        title: 'Rate',
        dataIndex: 'rate',
        render: (text, record) => (
           <span>$ 100</span>
        )
    }
]

const columns = [
    {
        title: 'First Name',
        dataIndex: 'firstName',
        key: 'firstName',
    },
    {
        title: 'Last Name',
        dataIndex: 'lastName',
        key: 'lastName',
    },
    {
        title: 'Date of Birth',
        dataIndex: 'eagleBoardReviewDate',
        key: 'eagleBoardReviewDate',
    },
    {
        title: 'Member ID',
        dataIndex: 'memberId',
        key: 'memberId',
    },
    {
        title: 'BOR Date',
        dataIndex: 'eagleBoardReviewDate',
        key: 'eagleBoardReviewDate',
    },
    {
        title: 'Eagle Information',
        children: [
            {
                title: 'Unit No.',
                dataIndex: 'eagleTroopNumber',
                key: 'eagleTroopNumber',
            },
            {
                title: 'Unit City',
                dataIndex: 'eagleCity',
                key: 'eagleCity',
            },
            {
                title: 'Unit State',
                dataIndex: 'eagleState',
                key: 'eagleState',
            },
        ]
    },
    {
        title: 'Membership Options',
        dataIndex: 'membershipoptions',
        key: 'membershipoptions',
        render: (text, record) => (
            <Radio.Group>
                <Radio value={1}>5 Years</Radio>
                <Radio value={2}>Lifetime</Radio>
            </Radio.Group>
        )
    }
];

const NESA_MID = process.env.REACT_APP_NESA_MID;
const TRANSACTION_FEE = process.env.REACT_APP_TRANSACTION_FEE;
class MulipleMembershipForm extends React.Component {
    selectphonecountryIDRef = createRef()
    constructor(props) {
        super(props);
        this.state = {
            ApprovedRecords: [],
            current: 0,
            value: 1,
            userDetails: "",
            TotalAmount: 0,
            SelectedMembership: 0,
            SelectedMembershipID: 0,
            SelectedMembershipName: '',
            SelectedMembershipPrice: 0,
            RushShipping: false,
            shipping_handlingCharge: '',
            isPayTransactionFees: false,
            ShowPaymentSummary: true,
            transactionFee: 0,
            NonUS: false,
            EagleInfo: '',
            Address: '',
            ethnic: '',
            hideNext: true,
            receipt_loading: false,
            ReceiptPara1: "",
            profilevalues: {},
            ReceiptPara2: "",
            minutes: 0,
            seconds: 20,
            ReceiptEmail: '',
            isVaildDate: '',
            showResultModal: false,
            EagleResults: [],
            memberSelectedKey: 0,
            selectedRecord: undefined,
            NoResultsMatchProfile: false,
            NoResultsFound: false,
            personGUID: undefined,
            firstname: '',
            middlename: '',
            lastname: '',
            address1: '',
            address2: '',
            city: '',
            zip: '',
            data: '',
            memberId: '',
            scouts_DOB: '',
            phoneCountryId: '',
            PhoneNumber: '',
            scouts_DOB_MaskChar: null,
            scouts_BOR: null,
            scoutsCountry: '616',
            membershipRecords: {},
            PromocodeApplied: false,
            isPromocodeRemoved: false,
            isPromoCodeEditable: true,
            DiscountAmount: 0,
            DiscountCode: '',
            createdPayments: {},
            getValidEagleState: undefined,
            getValidEagleCity: undefined,
        };

        this.ethnicities = this.ethnicities.bind(this)
        window.showPurchaseReceiptComponent = this
    }

    countries = () => {
        if (this.props.countries) {
            let countriesarray = this.props.countries.sort((a, b) => a.name - b.name)
            return countriesarray.map((k, index) => {
                return (
                    <option key={index} value={k.id}>{k.name}</option>
                )
            })
        }
    }
    getPhoneCode = () => {
        if (this.props.phonecode) {
            let phonecode = this.props.phonecode.sort((a, b) => a.name.localeCompare(b.name))
            return phonecode.map((k, index) => {
                return (
                    <option key={index} value={k.id}>{k.name}</option>
                )
            })
        }

    }
    showLoadingReceipt = () => {
        this.setState({
            receipt_loading: true
        })
        this.loadingInterval = setInterval(() => {
            const { seconds, minutes } = this.state

            if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds - 1
                }))
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(this.loadingInterval)
                } else {
                    this.setState(({ minutes }) => ({
                        minutes: minutes - 1,
                        seconds: 59
                    }))
                }
            }
        }, 1000)
    }

    getValidEagleStateHandler = (eagleState, eagleCity) => {
        let getValidEagleState, getValidEagleCity;
        let getEagleState = this.props.allstates.filter(state => {
            return state.short == eagleState
        })
        if (getEagleState.length == 0) {
            getValidEagleState = null;
            getValidEagleCity = null
        }
        else {
            getValidEagleState = eagleState;
            getValidEagleCity = eagleCity
        }

        return { getValidEagleState, getValidEagleCity }
    }

    selectMembership = (id, name, amt, SH_Fee) => {
        let transactionFee = ((amt + SH_Fee) * TRANSACTION_FEE) / 100;
        transactionFee = (Math.round(transactionFee * 100) / 100).toFixed(2);
        let total = (Math.round((amt + SH_Fee) * 100) / 100).toFixed(2);

        this.setState({
            SelectedMembershipID: id,
            SelectedMembershipName: name,
            SelectedMembershipPrice: (Math.round(amt * 100) / 100).toFixed(2),
            shipping_handlingCharge: (Math.round(SH_Fee * 100) / 100).toFixed(2),
            transactionFee: transactionFee,
            TotalAmount: total
        });
        const current = this.state.current + 1;
        this.setState({ current });
        this.props.actions.getEthnicities()
    }

    next() {
        const current = this.state.current + 1;
        this.setState({ current });
        this.props.actions.getEthnicities()
    }

    prev() {
        BackBtn = true;
        const current = this.state.current - 1;
        let length = this.state.EagleResults.length;
        if (current == 1) {
            this.setState({
                current,
                showResultModal: true
            });
        } else if (current == 1 && length == 1) {
            this.setState({
                current,
            })
        }
        else if (current == 2) {
            this.props.form.setFieldsValue({
                promocode: '',
            });
            let transactionFee = (((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
            let TotalAmount = (parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge) + (this.state.isPayTransactionFees ? parseFloat(transactionFee) : 0)).toFixed(2)

            this.setState({
                current,
                transactionFee,
                TotalAmount: TotalAmount,
                isPromocodeRemoved: true,
                PromocodeError: false,
                PromocodeApplied: false,
                isPromoCodeEditable: true,
                DiscountAmount: 0,
                DiscountCode: ''
            })
        }
        else if (current == 3 || current == 4) {
            this.setState({
                current,
            })
        }
        else {
            this.setState({ current });
        }
        this.props.actions.getEthnicities()
    }

    RushShipping = (e) => {
        if (e.target.checked) {
            this.setState({
                RushShipping: true,
                TotalAmount: parseInt(this.state.TotalAmount) + 40
            })
            this.props.actions.RegisterMembership(this.state.profilevalues, this.props.profileinfo, this.state.SelectedMembershipID, this.state.EagleInfo, true, this.state.TotalAmount + 40, "NESA", NESA_MID)
        } else {
            this.setState({
                RushShipping: false,
                TotalAmount: parseInt(this.state.TotalAmount) - 40
            })
            this.props.actions.RegisterMembership(this.state.profilevalues, this.props.profileinfo, this.state.SelectedMembershipID, this.state.EagleInfo, false, this.state.TotalAmount - 40, "NESA", NESA_MID)
        }

    }

    statesID = () => {
        if (this.props.allstates) {
            let statesarray = this.props.allstates
            return statesarray.map((k, index) => {
                return (
                    <option key={index} value={k.id}>{k.short}</option>
                )
            })
        }
    }
    promoButtons = () => {
        if (this.state.PromocodeApplied && this.state.isPromoCodeEditable) {
            return <Input disabled autoComplete="off" addonAfter={<Button style={{ backgroundColor: '#e60b2f', color: '#fff', borderColor: 'transparent' }} loading={this.state.applingPromocode} onClick={() => this.handlePromoRemove()} icon="close">{this.state.removingPromocode ? 'Removing' : 'Remove'}</Button>} size="small" className='promocodeInput' placeholder="Code" />
        }
        else if (this.state.isPromoCodeEditable) {
            return <Input autoComplete="off" addonAfter={<Button type="primary" loading={this.state.applingPromocode} htmlType='submit' icon="check">Apply</Button>} size="small" className='promocodeInput' placeholder="Code" />
        }
        else if (!this.state.isPromoCodeEditable) {
            return <Input disabled autoComplete="off" addonAfter={<Button type="default" className='successBtn' icon="check-circle">applied</Button>} size="small" className='promocodeInput' placeholder="Code" />
        }
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {

            if (!err) {
                let isRush = false

                //adding membershiptype
                values.MembershipType = this.state.SelectedMembershipID

                let selectedRecord = { ...this.state.selectedRecord }
                selectedRecord.dob = this.state.scouts_DOB

                values.scout_state = this.state.getValidEagleState
                values.scout_city = this.state.getValidEagleCity

                this.setState({
                    memberId: values.memberid,
                    firstname: values.firstname,
                    middlename: values.middlename,
                    lastname: values.lastname,
                    address1: values.addressline1,
                    address2: values.addressline2,
                    city: values.city,
                    zip: values.zipcode,
                    data: values,
                    selectedRecord
                })

                values.isPayTransactionFees = this.state.isPayTransactionFees
                values.transactionFee = this.state.transactionFee

                let amount = (parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge) + (this.state.isPayTransactionFees ? parseFloat(this.state.transactionFee) : 0)).toFixed(2)
                this.props.actions.RegisterMembership(values, selectedRecord, this.state.SelectedMembershipID, values, isRush, parseFloat(amount), "NESA", NESA_MID)

                let statesarray = this.props.allstates
                statesarray.map((k, index) => {
                    if (k.id == values.state)
                        return values.stateName = k.short
                })

                this.setState({
                    userDetails: values
                })
            }
        })
    }
    calculateFee = () => {
        let transactionFee = ((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100
        let totalPrice = this.state.isPayTransactionFees ? parseFloat(this.state.TotalAmount) - transactionFee : parseFloat(this.state.TotalAmount) + transactionFee;
        totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
        this.setState({
            isPayTransactionFees: !this.state.isPayTransactionFees,
            TotalAmount: totalPrice
        })
    }

    InitTrans = () => {
        this.props.actions.InitOrbitalPayments(this.state.TotalAmount, 'NESA', NESA_MID, this.state.membershipRecords, this.state.email, this.state.PhoneNumber, this.state.createdPayments)
        if (this.state.PromocodeApplied) {
            this.setState({
                isPromoCodeEditable: false
            })
        }
    }

    renderPaymentSummary = () => {
        const { getFieldDecorator } = this.props.form;
        return (<div className="payment-summary centered" style={{ marginBottom: '40px' }} >
            <Form className="search-form alumni-ui">
                <Row type="flex" justify="center" align="center">


                    <Col className="card-margin" span={24}>
                        <Card
                            className="centered"
                            title="SUMMARY"

                        >
                            <div style={{ padding: "10px 30px" }}>
                                <Row >
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Table bordered pagination={false} dataSource={this.state.ApprovedRecords} columns={summaryColumns} />
                                    </Col>
                                </Row>
                               <Row style={{ marginTop:'20px' }}>
                                    <Col xs={24} sm={24} md={12} lg={18} xl={18}>
                                        <div className="summary-label-txt right" style={{  fontSize: '14px' }} > Subtotal</div>
                                    </Col>

                                    <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                                        <div className="summary-label-txt" style={{ marginLeft: '20px', textAlign: 'left'}}>$ 100</div>
                                    </Col>
                                </Row>
                                <Row >
                                    <Col xs={24} sm={24} md={12} lg={18} xl={18}>
                                        <div className="summary-label-txt right" style={{ fontSize: '14px' }} >{this.state.SelectedMembershipName} Discount</div>
                                    </Col>

                                    <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                                        <div className="summary-label-txt" style={{ marginLeft: '20px', textAlign: 'left'}}>$ 10</div>
                                    </Col>
                                </Row>
                                <Row >
                                    <Col xs={24} sm={24} md={12} lg={18} xl={18}>
                                        <div className="summary-label-txt right" style={{ fontSize: '14px' }} >{this.state.SelectedMembershipName} Shipping/Handling</div>
                                    </Col>

                                    <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                                        <div className="summary-label-txt" style={{ marginLeft: '20px', textAlign: 'left'}}>$ 0{this.state.shipping_handlingCharge}</div>
                                    </Col>
                                </Row>
                                {/* {this.state.isPayTransactionFees && */}
                                    <Row >
                                        <Col xs={24} sm={24} md={12} lg={18} xl={18}>
                                            <div className="summary-label-txt right" style={{ fontSize: '14px' }} >Transaction Fee</div>
                                        </Col>

                                        <Col xs={24} sm={24} md={12} lg={6} xl={6} className="right">
                                            <div className="summary-label-txt" style={{ marginLeft: '20px', textAlign: 'left'}}>$ {this.state.transactionFee}</div>
                                        </Col>
                                    </Row>
                                {/* } */}
                                <Divider style={{ margin: '10px 0px' }} />
                                <Row type="flex" align="middle" justify="center" >
                                    <Col xs={24} sm={24} md={12} lg={18} xl={18}>
                                        <div className="summary-label-txt right" style={{ marginBottom: '0px', fontSize: '14px' }}>
                                            TOTAL CHARGE
                                </div>
                                        {/* <div className="summary-label-txt" style={{ fontSize: '14px' }} ></div> */}
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={6} xl={6} className="">
                                        <div className="summary-price" style={{ marginLeft: '20px', textAlign: 'left'}}>$ 10{this.state.TotalAmount}</div>
                                    </Col>
                                </Row>
                                {/* 
                            <Row >
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div className="summary-label-txt" style={{ fontSize: '14px' }} >{this.state.firstname} {this.state.middlename} {this.state.lastname}</div>
                                </Col>
                            </Row> */}
                                {/* <Row style={{ display: 'flex', justifyContent: 'center' }}>
                                <Col className='xs-center sm-center' xs={14} sm={14} md={8} lg={8} xl={8}>
                                    {this.renderSearchButton()}
                                </Col>
                            </Row> */}
                            </div>

                        </Card>
                    </Col>
                </Row>

                <div className="steps-action centered" style={{ width: '100%' }}>
                    <Row style={{ position: "unset" }}>
                        <Col xs={24} sm={24} md={14} lg={14} xl={14}  >
                            <div className="text-result pointer"
                                style={{ marginTop: "55px", marginBottom: '55px' }}
                                onClick={() => {
                                    // let total = (Math.round((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * 100) / 100).toFixed(2);
                                    // this.setState({
                                    //     current: 0,
                                    //     ShowPaymentSummary: true,
                                    //     isPayTransactionFees: false,
                                    //     TotalAmount: total
                                    // })
                                    // history.push('/purchase-membership')
                                    this.prev()
                                }}><i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i> Back to Eagle Info</div>
                        </Col>
                        {/* <Col className='xs-center sm-center ' xs={24} sm={24} md={14} lg={14} xl={14} offset={2}>
                                                        <FormItem>
                                                            <Button type="primary" style={{ width: '100%' }} className='back-btn' onClick={() => this.prev()}>This is not me</Button>
                                                        </FormItem>
                                                    </Col> */}
                        <Col className='xs-center sm-center' xs={24} sm={24} md={8} lg={8} xl={8} offset={1}>
                            {this.renderPayNowButton()}
                        </Col>
                    </Row>
                </div>
            </Form>
        </div>)
    }
    renderIframe = () => {
        if (this.props.initloading == true) {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Chase Payments..." />
                </Col>
            </Row>
        }
        else if (this.props.registration_loading) {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Please Wait..." />
                </Col>
            </Row>
        }
        else if (this.props.initTransaction) {
            return <Row className="chase-payment">
                <Col span={24}>
                    <Iframe src={`${CHASE_URL}` + this.props.initTransaction.uID} height="700px" width="100%" />
                </Col>
            </Row>
        }
        else {
            return <Row>
                <Col span={24} className="centered margin-top-30">
                    <div className="margin-bottom-20">Unable to load the payment form. Please try again.</div>
                    <Button type="primary" onClick={() => this.InitTrans()}>Try Again</Button>
                </Col>
            </Row>
        }
    }


    showReceipt = (RegID, response) => {
        setTimeout(
            function () {
                this.props.actions.getRegStatusandSendReceipt(RegID, this.state.userDetails, "NESA", this.state.ReceiptEmail, response)
            }
                .bind(this),
            15000
        );
    }

    renderReceiptpage = () => {
        if (this.props.regstatus) {
            if (this.props.regstatus[0].applicationStatusId == "4") {
                this.setState({
                    ReceiptPara1: PENDING_MEMBERSHIP_TEXT
                })
            }
            if (this.props.regstatus[0].applicationStatusId == "21") {
                this.setState({
                    ReceiptPara1: CONFIRM_MEMBERSHIP_TEXT
                })
            }
            this.setState({
                current: 5
            })
        }
    }

    renderLevels = () => {
        if (this.props.productprice_loading) {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading NESA levels..." />
                </Col>
            </Row>
        }
        if (this.props.nesa_levels && this.props.productprice) {
            let nesalevels = this.props.nesa_levels
            let productprice = this.props.productprice;


            return nesalevels.map((k, index) => {
                let price = 0;
                let shipping_handlingCharge = 0;
                let shipping_StructureCode;
                let productname = (k.name).replace(/-/g, " ")
                productprice.map((j, index) => {
                    if (k.name == j.feeStructureCode) {
                        price = (Math.round(j.termFee * 100) / 100).toFixed(2);
                        if (k.name.includes("5Year")) { //if (k.name == "NESA-Silver-5Year") {
                            shipping_StructureCode = "NESA5SH"
                        } else if (k.name.includes("Lifetime")) { //  } else if (k.name == "NESA-Gold-Lifetime") {
                            shipping_StructureCode = "NESALIFESH"
                        }
                    }
                })

                productprice.map((j, index) => {
                    if (shipping_StructureCode == j.feeStructureCode) {
                        shipping_handlingCharge = (Math.round(j.termFee * 100) / 100).toFixed(2);
                    }
                })

                return <Col xs={24} sm={24} md={12} lg={12}>
                    <div className="membership-card">
                        <img src="../NESA.png" className='NESA-logo' />
                        <span className="membership-level">{productname}</span>
                        <span className="membership-price">$ {price}</span>
                        <Button className="membership-start" onClick={() => this.selectMembership(k.id, productname, Number(price), Number(shipping_handlingCharge))}>START</Button>
                    </div>
                </Col>
            })
        }
    }

    notDefaultDate = (rule, value, callback) => {
        const { form } = this.props;
        if (value && moment(value).format('DD/MM/YYYY') == '01/01/1901') {
            callback('Not a valid date!');
        } else {
            callback();
        }
    };

    render_nonUSA_address = () => {

        const { getFieldDecorator } = this.props.form;
        const stateInputEle = () => { return <input maxLength={2} style={{ textTransform: 'uppercase' }} autoComplete={'off'} /> };

        return (<Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
            <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem
                        label="Your Country"
                    >
                        {getFieldDecorator('countryId', {
                            initialValue: this.state.scoutsCountry ? `${this.state.scoutsCountry}` : "616",
                            rules: [{ required: true, message: 'Enter Your Country!' }],
                        })(
                            <Select
                                // className={this.state.scoutsCountry ? 'input-disabled' : ''}
                                // disabled={this.state.scoutsCountry ? true : false}
                                showAction={['focus', 'click']}
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="Select a Country"
                                optionFilterProp="children"
                                onChange={(e) => {
                                    this.setState({
                                        scoutsCountry: e,
                                    })
                                }}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                {this.countries()}
                            </Select>
                        )}
                    </FormItem>
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label={(
                            <span>
                                Address Line 1&nbsp;
                                <Tooltip placement="top" title="Represents street address (2423 Brighton Rd; 17 Downing Street)Combine the normal 2 line address into a single address, separating the house unit from street address via comma (2423 Brighton Road, Apt. 3; 17 Downing Street, Section 7)">
                                    <Icon type="info-circle-o" />
                                </Tooltip>
                            </span>
                        )}
                    >
                        {getFieldDecorator('addressline1', {
                            initialValue: this.state.selectedRecord.address1 ? this.state.selectedRecord.address1 : "",
                            rules: [{ required: true, message: 'Enter Your Address!' }],
                        })(
                            <Input placeholder="Address Line 1"
                            // className={this.state.selectedRecord.address1 ? 'input-disabled' : ''}
                            // disabled={this.state.selectedRecord.address1 ? true : false}
                            />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        style={{ marginBottom: '0px' }}
                        label={(
                            <span>
                                Address Line 2&nbsp;
                                <Tooltip placement="top" title="Represents a unit, number or subset of the street address (Apt. 12; Section 3; Dept. 22)">
                                    <Icon type="info-circle-o" />
                                </Tooltip>
                            </span>
                        )}
                    //extra="City, Territory, Postal Code, Country"
                    >
                        {getFieldDecorator('addressline2', {
                            initialValue: this.state.selectedRecord.address2 ? this.state.selectedRecord.address2 : "",
                            rules: [{ required: false, message: 'Enter Your Address!' }],
                        })(
                            <Input placeholder="Address Line 2"
                            // className={this.state.selectedRecord.address2 ? 'input-disabled' : ''}
                            // disabled={this.state.selectedRecord.address2 ? true : false} 
                            />
                        )}
                    </FormItem>
                </Col>

            </Row>

            <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        style={{ marginBottom: '0px' }}
                        label={(
                            <span>
                                Address Line 3&nbsp;
                                 <Tooltip placement="top" title="List the city, territory, postal code and country according to country standards (Southampton, SO53 5PD, UK; Vancouver, BC V5X 2H6">
                                    <Icon type="info-circle-o" />
                                </Tooltip>
                            </span>
                        )}
                        extra="City, Territory, Postal Code, Country"
                    >
                        {getFieldDecorator('addressline3', {
                            initialValue: this.state.selectedRecord.address3 ? this.state.selectedRecord.address3 : "",
                            rules: [{ required: true, message: 'Enter Your Address!' }],
                        })(
                            <Input placeholder="Address Line 3"
                            // className={this.state.selectedRecord.address3 ? 'input-disabled' : ''}
                            // disabled={this.state.selectedRecord.address3 ? true : false} 
                            />
                        )}
                    </FormItem>
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your Phone"
                    >
                        {getFieldDecorator('phone', {
                            initialValue: this.state.selectedRecord.phone ? (this.state.PhoneNumber) ? this.state.PhoneNumber.toString() : this.state.selectedRecord.phone.toString() : '',
                            rules: [{ required: true, min: 10, max: 10, message: 'Enter Your Phone Number!' },
                            {
                                pattern: new RegExp("^[0-9]*$"),
                                message: "Phone Number must be all numeric!"
                            }],
                        })(
                            <Input
                                // className={this.state.PhoneNumber ? 'input-disabled' : ''}
                                // disabled={(this.state.PhoneNumber) ? true : false}
                                addonBefore={
                                    getFieldDecorator('phonecountryID', {
                                        rules: [{ required: true, message: 'Select Phone Country ID' }],
                                        initialValue: this.state.phoneCountryId ? `${this.state.phoneCountryId}` : "636",
                                        // initialValue:  "636",
                                    })(
                                        <Select style={{ width: 100 }} ref={this.selectphonecountryIDRef} onSelect={() => this.selectphonecountryIDRef.current.blur()}>
                                            {this.getPhoneCode()}
                                        </Select>
                                    )
                                } />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your Email"
                    >
                        {getFieldDecorator('email', {
                            initialValue: this.state.selectedRecord.email ? this.state.selectedRecord.email : "",
                            rules: [{ required: true, type: "email", message: 'Enter valid email address!' }]
                        })(
                            <Input placeholder="Email"
                            // disabled={this.state.selectedRecord.email ? true : false}
                            // className={this.state.selectedRecord.email ? 'input-disabled' : ''}
                            />
                        )}
                    </FormItem>
                </Col>

            </Row>

        </Row>
        )
    }
    render_USA_address = () => {

        const { getFieldDecorator } = this.props.form;
        const stateInputEle = () => { return <input maxLength={2} style={{ textTransform: 'uppercase' }} autoComplete={'off'} /> };

        return (<Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
            <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem
                        label="Your Country"
                    >
                        {getFieldDecorator('countryId', {
                            initialValue: this.state.scoutsCountry ? `${this.state.scoutsCountry}` : "616",
                            rules: [{ required: true, message: 'Enter Your Country!' }],
                        })(
                            <Select
                                // className={this.state.scoutsCountry ? 'input-disabled' : ''}
                                // disabled={this.state.scoutsCountry ? true : false}
                                showAction={['focus', 'click']}
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="Select a Country"
                                optionFilterProp="children"
                                onChange={(e) => {
                                    this.setState({
                                        scoutsCountry: e,
                                    })
                                }}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                {this.countries()}
                            </Select>
                        )}
                    </FormItem>
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your Address Line 1"
                    >
                        {getFieldDecorator('addressline1', {
                            initialValue: this.state.selectedRecord.address1 ? this.state.selectedRecord.address1 : "",
                            rules: [{ required: true, message: 'Enter Your Address!' }],
                        })(
                            <Input placeholder="Address Line 1"
                            // className={this.state.selectedRecord.address1 ? 'input-disabled' : ''}
                            // disabled={this.state.selectedRecord.address1 ? true : false}
                            />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your Address Line 2"
                    >
                        {getFieldDecorator('addressline2', {
                            initialValue: this.state.selectedRecord.address2 ? this.state.selectedRecord.address2 : "",
                            rules: [{ required: false, message: 'Enter Your Address!' }],
                        })(
                            <Input placeholder="Address Line 2"
                            // className={this.state.selectedRecord.address2 ? 'input-disabled' : ''}
                            // disabled={this.state.selectedRecord.address2 ? true : false} 
                            />
                        )}
                    </FormItem>
                </Col>

            </Row>

            <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your Address Line 3"
                    >
                        {getFieldDecorator('addressline3', {
                            initialValue: this.state.selectedRecord.address3 ? this.state.selectedRecord.address3 : "",
                            rules: [{ required: false, message: 'Enter Your Address!' }],
                        })(
                            <Input placeholder="Address Line 3"
                            // className={this.state.selectedRecord.address3 ? 'input-disabled' : ''}
                            // disabled={this.state.selectedRecord.address3 ? true : false} 
                            />
                        )}
                    </FormItem>
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your City"
                    >
                        {getFieldDecorator('city', {
                            initialValue: this.state.selectedRecord.city ? this.state.selectedRecord.city : "",
                            rules: [{ required: true, min: 2, message: 'Enter Your City!' }],
                        })(
                            <Input placeholder="City"
                            // className={this.state.selectedRecord.city ? 'input-disabled' : ''}
                            // disabled={this.state.selectedRecord.city ? true : false} 
                            />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your State"
                    >
                        {getFieldDecorator('state', {
                            initialValue: this.state.selectedRecord.stateId ? `${this.state.selectedRecord.stateId}` : "",
                            rules: [{ required: true, message: 'Enter Your State!' }],
                        })(
                            <Select
                                // disabled={this.state.selectedRecord.stateId ? true : false}
                                getInputElement={stateInputEle}
                                showAction={['focus', 'click']}
                                showSearch
                                style={{ width: '100%', textTransform: 'uppercase' }}
                                placeholder="Select a State"
                                optionFilterProp="children"
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                {this.statesID()}
                            </Select>
                        )}
                    </FormItem>
                </Col>


            </Row>

            <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your ZIP Code"
                    >
                        {getFieldDecorator('zipcode', {
                            initialValue: this.state.selectedRecord.zipCode ? this.state.selectedRecord.zipCode.toString() : "",
                            rules: [{ required: true, max: 5, message: 'Enter Your ZIP Code!' }],
                        })(
                            <Input placeholder="ZIP Code"
                                // className={this.state.selectedRecord.zipCode ? 'input-disabled' : ''}
                                // disabled={this.state.selectedRecord.zipCode ? true : false}
                                maxLength={5}
                            // style={this.state.selectedRecord.zipCode ? {background: '#f5f5f5 '} : ''}
                            />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your Phone"
                    >
                        {getFieldDecorator('phone', {
                            initialValue: this.state.selectedRecord.phone ? (this.state.PhoneNumber) ? this.state.PhoneNumber.toString() : this.state.selectedRecord.phone.toString() : '',
                            rules: [{ required: true, min: 10, max: 10, message: 'Enter Your Phone Number!' },
                            {
                                pattern: new RegExp("^[0-9]*$"),
                                message: "Phone Number must be all numeric!"
                            }],
                        })(
                            <Input
                                // className={this.state.PhoneNumber ? 'input-disabled' : ''}
                                // disabled={(this.state.PhoneNumber) ? true : false}
                                addonBefore={
                                    getFieldDecorator('phonecountryID', {
                                        rules: [{ required: true, message: 'Select Phone Country ID' }],
                                        initialValue: this.state.phoneCountryId ? `${this.state.phoneCountryId}` : "636",
                                        // initialValue:  "636",
                                    })(
                                        <Select style={{ width: 100 }} ref={this.selectphonecountryIDRef} onSelect={() => this.selectphonecountryIDRef.current.blur()}>
                                            {this.getPhoneCode()}
                                        </Select>
                                    )
                                } />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your Email"
                    >
                        {getFieldDecorator('email', {
                            initialValue: this.state.selectedRecord.email ? this.state.selectedRecord.email : "",
                            rules: [{ required: true, type: "email", message: 'Enter valid email address!' }]
                        })(
                            <Input placeholder="Email"
                            // disabled={this.state.selectedRecord.email ? true : false}
                            // className={this.state.selectedRecord.email ? 'input-disabled' : ''}
                            />
                        )}
                    </FormItem>
                </Col>
            </Row>
        </Row>
        )
    }

    renderEagleInfo = () => {

        if (this.state.selectedRecord) {
            const { getFieldDecorator } = this.props.form;
            let eagleinfo = this.state.selectedRecord
            let isEagle = eagleinfo.eagleBoardReviewDate != null ? true : false

            return <Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <FormItem
                            label={(
                                <span>
                                    Eagle Scout Member ID&nbsp;
                                    <Tooltip placement="top" title="Your MemberID associated with your BOR date">
                                        <Icon type="info-circle-o" />
                                    </Tooltip>
                                </span>
                            )}
                        >
                            {getFieldDecorator('member_id', {
                                initialValue: eagleinfo ? eagleinfo.memberId ? eagleinfo.memberId : '' : '',
                                // rules: [{ required: true, message: 'Enter Member ID!' }],
                            })(
                                <Input className={eagleinfo ? eagleinfo.memberId ? "input-disabled" : '' : ''} disabled={eagleinfo ? eagleinfo.memberId ? true : false : false} placeholder="Eagle Scout Member ID" />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <FormItem
                            label="Eagle Scout Board of Review Date"
                            hasFeedback
                            validateStatus={this.state.isVaildDate}
                            onClick={() => this.setState({ scouts_BOR: '-' })}
                        >
                            {getFieldDecorator('review_date', {
                                initialValue: eagleinfo ? eagleinfo.eagleBoardReviewDate ? moment(eagleinfo.eagleBoardReviewDate).format('MM/DD/YYYY') : '' : '',
                                rules: [
                                    { required: true, message: 'Enter Eagle Scout Board of Review Date!' },
                                    {
                                        pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                        message: `Please enter correct format MM/DD/YYYY Pattern`
                                    }
                                ],
                            })(
                                // <DatePicker disabled={isEagle} style={{ width: '100%' }} placeholder='MM/DD/YYYY' format="MM/DD/YYYY" />
                                <InputMask
                                    mask="99/99/9999"
                                    style={eagleinfo ? eagleinfo.eagleBoardReviewDate ? { background: '#f5f5f5 ' } : { background: '#fff' } : { background: '#fff' }}

                                    // disabled={eagleinfo ? eagleinfo.eagleBoardReviewDate ? true : false :false}
                                    placeholder='MM/DD/YYYY'
                                    alwaysShowMask
                                    maskChar={this.state.scouts_BOR}
                                    className="ant-input"
                                    onChange={(e) => {
                                        this.format_Date(e, 'BOR')
                                    }}
                                    render={(ref, props) => (
                                        <Input /> //disabled={eagleinfo ? eagleinfo.eagleBoardReviewDate ? true : false :false}  />
                                    )}
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <FormItem
                            label={(
                                <span>
                                    Eagle Scout Unit Number&nbsp;
                                    <Tooltip placement="top" title="Please Enter Four Digit Unit Number. Eg: 0001, 0018, 0234">
                                        <Icon type="question-circle-o" />
                                    </Tooltip>
                                </span>
                            )}
                        >
                            {getFieldDecorator('scout_unit', {
                                initialValue: eagleinfo ? eagleinfo.unitNumber ? eagleinfo.unitNumber : '' : "",
                                rules: [
                                    // {required:true},
                                    { max: 4, message: 'Unit Number must be four digits!' },
                                    {
                                        pattern: new RegExp("^[0-9]*$"),
                                        message: "Unit Number must be all numeric!"
                                    }],
                            })(
                                <Input  disabled={eagleinfo ? eagleinfo.unitNumber ? true : false : false} maxLength={4} placeholder="Eagle Scout Unit " />
                            )}
                        </FormItem>
                    </Col>
                </Row>

                <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <FormItem
                            label=" Eagle Scout Unit City"
                        >
                            {getFieldDecorator('scout_city', {
                                initialValue: isEagle ? eagleinfo.eagleCity : "",
                                rules: [{
                                    // required: true,
                                    message: 'Enter Your Eagle Scout Unit City!'
                                }],
                            })(
                                <Input disabled={isEagle} className={isEagle ? "input-disabled" : ''} placeholder="Eagle Scout Unit City" />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <FormItem
                            label=" Eagle Scout Unit State"
                        >
                            {getFieldDecorator('scout_state', {
                                initialValue: isEagle ? eagleinfo.eagleState : "",
                                rules: [{
                                    // required: true,
                                    message: 'Enter Your Eagle Scout Unit State!'
                                }],
                            })(
                                <Select
                                    disabled={isEagle}
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="Select a State"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {this.statesID()}
                                </Select>
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        {/* <FormItem
                        label="Eagle Council"
                    >
                        {getFieldDecorator('scout_council', {
                            initialValue: isEagle ? eagleinfo.eagleCouncilName : "",
                            // rules: [{ required: true, message: 'Enter your Eagle Scout Unit City!' }],
                        })(
                            <Input disabled={isEagle} className={isEagle ? "input-disabled" : ''} placeholder="Eagle Council Name" />
                        )}
                    </FormItem> */}
                    </Col>
                </Row>
            </Row>
        }
        else {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Eagle information..." />
                </Col>
            </Row>
        }
    }


    ethnicities = () => {
        if (this.props.ethnicities) {
            let ethnicitiesArray = this.props.ethnicities
            return ethnicitiesArray.map((k, index) => {
                return (
                    <option key={index} value={k.short}>{k.name}</option>
                )
            })
        }
    }

    setAddress = (address) => {
        this.setState({
            Address: address
        })
    }

    changeEthinicity = (e) => {
        this.setState({
            ethnic: e
        })
    }

    isEditMode = (editmode) => {
        if (editmode) {
            this.setState({
                hideNext: false
            })
        } else {
            this.setState({
                hideNext: true
            })
        }
    }

    renderpersonalInfo = () => {
        if (this.props.profileloading) {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Personal Information..." />
                </Col>
            </Row>
        }
        if (this.props.profileinfo) {
            const { getFieldDecorator } = this.props.form;
            let profileInfo = this.props.profileinfo
            let personemail =  this.props.profileinfo.emails.length > 0 ? this.props.profileinfo.emails.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0] : ''
            let email = personemail ? personemail.email : ""
            let address =  this.props.profileinfo.addresses.length > 0 ? this.props.profileinfo.addresses.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0] : ''
            if (this.state.Address == '') {
                this.setAddress(address)
            }
            let personethnicity = this.props.profileinfo.extendedProfile.filter((data) => data.attributeId == "1")[0]
            return <Row gutter={48}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <FormItem
                        label="First Name"
                    >
                        {getFieldDecorator('first_name', {
                            initialValue: profileInfo.profile.firstName,
                            rules: [{ required: false, message: 'Enter your First Name!' }],
                        })(
                            <Input placeholder="First Name" className="input-disabled" disabled />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <FormItem
                        label="Last Name"
                    >
                        {getFieldDecorator('last_name', {
                            initialValue: profileInfo.profile.lastName,
                            rules: [{ required: false, message: 'Enter your Last Name!' }],
                        })(
                            <Input placeholder="Last Name" className="input-disabled" disabled />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <FormItem
                        label="Email"
                    >
                        {getFieldDecorator('email', {
                            initialValue: email,
                            rules: [{ required: true, type: "email", message: 'Enter valid email address!' }]
                        })(
                            <Input placeholder="Email" />
                        )}
                    </FormItem>
                </Col>
                {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <FormItem
                        label="Ethnic Background"
                    >
                        {getFieldDecorator('ethnic_background', {
                            initialValue: (personethnicity && personethnicity.attributeVal && this.state.ethnic == '') ? personethnicity.attributeVal : this.state.ethnic,
                            rules: [{ 
                                // required: true,
                                 message: 'Enter your Ethnic Background!' }],
                        })(
                            <Select style={{ width: '100%' }} onChange={this.changeEthinicity.bind(this)} >
                                {this.ethnicities()}
                            </Select>
                        )}
                    </FormItem>
                </Col> */}
                {/* <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Certificate Date"
                            onClick={() => this.setState({ scouts_DOB_MaskChar: '-' })}
                        >
                            {getFieldDecorator('certificate_date', {
                                initialValue:  '',
                                rules: [{ required: true, message: 'Enter the Certificate Date!' }],
                            })(
                                <InputMask
                                    // style={{ background: '#f5f5f5 ' }}
                                    className="ant-input"
                                    mask="99/99/9999"
                                    placeholder='MM/DD/YYYY'
                                    alwaysShowMask
                                    maskChar={'-'}
                                    onChange={(e) => {
                                        this.format_Date(e, "C_DATE")
                                    }}
                                    render={(ref, props) => (
                                        <Input />
                                    )} />
                            )}
                        </FormItem>
                    </Col> */}
            </Row>
        }

        return <Row>
            <Col span={24}>
                <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Personal Information..." />
            </Col>
        </Row>
    }

    renderPayNowButton = () => {
        if (this.props.initloading) {
            return <FormItem> <Button type="primary" className='submit-btn' loading > Loading ...</Button></FormItem>
        } else {
            return (
                <FormItem>
                    <Button type="primary" style={{ width: '100%' }} className='submit-btn' onClick={() => this.InitTrans()} > Pay Now</Button>
                </FormItem>
            )
        }
    }

    renderPaymentButton = () => {

        if ((this.props.response && this.props.createdPayments) && !BackBtn) {
            this.next()
        }
        if (this.props.loading || this.props.creatingPayments) {
            return <FormItem> <Button type="primary" style={{ width: '100%' }} className='submit-btn' loading > Loading ...</Button></FormItem>
        } else {
            if (this.state.hideNext) {
                return <FormItem> <Button type="primary" className='submit-btn' style={{ width: '100%' }} onClick={() => this.next()} >NEXT</Button> </FormItem>
            }
        }
    }

    componentDidMount = () => {
        this.props.actions.getProductPrice()
        this.props.actions.getNESAmembershiplevels()
        this.props.actions.getEthnicities()
        this.props.actions.getStates()
        this.props.actions.getCountries()
        this.props.actions.getPhoneCountries()
        // this.props.actions.getEagleInfo()
    }
    componentWillReceiveProps = (nextprops) => {
        if (this.props.response !== nextprops.response) {
            if (nextprops.response) {
                this.setState({
                    membershipRecords: nextprops.response,
                })
            }
        }
        if (this.props.createdPayments !== nextprops.createdPayments) {
            if (nextprops.createdPayments) {
                this.setState({
                    createdPayments: nextprops.createdPayments,
                    current: 3
                })
            }
        }
        if (this.props.initTransaction !== nextprops.initTransaction) {
            if (nextprops.initTransaction) {
                let isPromoCodeEditable = !this.state.PromocodeApplied
                this.setState({
                    isPromoCodeEditable,
                    current: 4
                })
            }
        }
        if (this.props.searchedEagle !== nextprops.searchedEagle) {
            if (nextprops.searchedEagle) {
                let filterSearchedEagle;
                // if (nextprops.searchedEagle.length >= 1) {
                filterSearchedEagle = nextprops.searchedEagle.filter(each => {
                    return each.eagleBoardReviewDate != "" && each.eagleBoardReviewDate != null && each.eagleCertificationDate != "" && each.eagleCertificationDate != null && each.memberId != '' && each.memberId != null
                })
                //     } else {
                //         filterSearchedEagle = nextprops.searchedEagle
                //    }
                if (this.props.allstates) {
                    filterSearchedEagle.map(eachRec => {
                        this.props.allstates.map(item => {
                            if (item.short == eachRec.state) {
                                eachRec.stateId = item.id
                            }
                        })
                    })
                }

                let length = filterSearchedEagle.length
                let phoneCountryId = ""
                let PhoneNumber = ""
                if (length > 0 && filterSearchedEagle[0].phone.length == 13) {
                    let getCountryShort = filterSearchedEagle[0].phone.slice(0, 3).toString();
                    if (this.props.phonecode) {
                        this.props.phonecode.map(code => {
                            if (getCountryShort == code.short) {
                                phoneCountryId = code.id
                            }
                        })
                    }
                    PhoneNumber = filterSearchedEagle[0].phone.slice(3);
                } else if (length > 0) {
                    PhoneNumber = filterSearchedEagle[0].phone.replace(/ /g, '');
                }

                if (length === 0) {
                    this.show_NoResultsFound_Modal();
                } else {
                    this.setState({ NoResultsFound: false });
                }
                
                if (length == 1) {
                    // const current = this.state.current + 1;
                    // this.props.actions.getProfileInfo(filterSearchedEagle[0].personGuid)
                    // this.props.actions.getAlumniEagleInfo(filterSearchedEagle[0].personGuid)

                    let getValidEagleDetails = this.getValidEagleStateHandler(filterSearchedEagle[0].eagleState, filterSearchedEagle[0].eagleCity)
                    this.showResults()
                    this.setState(
                        {

                            personGUID: filterSearchedEagle[0].personGuid,
                            EagleResults: filterSearchedEagle,
                            selectedRecord: filterSearchedEagle[0],
                            scoutsCountry: filterSearchedEagle[0].countryId,
                            phoneCountryId,
                            PhoneNumber,
                            getValidEagleState: getValidEagleDetails.getValidEagleState,
                            getValidEagleCity: getValidEagleDetails.getValidEagleCity
                        }
                    );
                }
                if (length > 1) {
                    this.showResults()
                    let getValidEagleDetails = this.getValidEagleStateHandler(filterSearchedEagle[0].eagleState, filterSearchedEagle[0].eagleCity)
                    this.setState({
                        // showResultModal: true,
                        phoneCountryId,
                        PhoneNumber,
                        selectedRecord: filterSearchedEagle[0],
                        scoutsCountry: filterSearchedEagle[0].countryId,
                        EagleResults: filterSearchedEagle,
                        personGUID: filterSearchedEagle[0].personGuid,
                        getValidEagleState: getValidEagleDetails.getValidEagleState,
                        getValidEagleCity: getValidEagleDetails.getValidEagleCity
                    })
                }
                // if (length === 0)
                //     this.show_NoResultsFound_Modal()
            }
        }

    }
    
    componentDidUpdate(prevProps) {
  if (
    !prevProps.regError &&
    this.props.regError &&
    this.state.receipt_loading
  ) {
    this.setState({ receipt_loading: false });

    const { errorCode, message, errorDesc } = this.props.regError;

    Modal.error({
      title: `Error ${errorCode || ""}`,
      content: (
        <div>
          <p><b>{message || "Request failed"}</b></p>
          {errorDesc && <p>{errorDesc}</p>}
        </div>
      )
    });
  }
}

    showIneligibleStatusModal = () => {
        this.setState({
            ShowIneligibleStatus: true
        })
    }

    closeIneligibleStatusModal = () => {
        this.setState({
            ShowIneligibleStatus: false
        })
    }

    CloseIneligibleToDashboard = () => {
        this.setState({
            ShowIneligibleStatus: false
        })
        // history.push('/')
    }

    showSearchStatus = (title, text) => {
        Modal.warning({
            title: title,
            content: text,
        });
    }
    componentWillUnmount() {
        clearInterval(this.loadingInterval)
    }

    showResults = () => {
        this.setState({
            showResultModal: true
        })
    }

    closeResult = () => {
        this.setState({
            showResultModal: false
        })
    }
    closeNorecordsMatchProfile = () => {
        this.setState({
            NoResultsMatchProfile: false
        })
        // history.push('/my-profile')
    }

    show_NoResultsFound_Modal = () => {
        this.setState({
            NoResultsFound: true
        })
    }
    close_NoResultsFound_Modal = () => {
        this.setState({
            NoResultsFound: false
        })
        // history.push('/my-profile')
    }
    renderSearchButton = () => {
        if (this.props.response && !BackBtn) {
            this.next()
        }
        // if (this.props.loading) {
        //     return <FormItem> <Button type="primary" className='submit-btn' style={{ margin: 0, float: 'unset', width: "100%" }} loading > Loading ...</Button></FormItem>
        // } else {
        return <FormItem> <Button type="primary" className='submit-btn' style={{ margin: 0, float: 'unset', width: "100%" }} htmlType='submit'>{this.props.searching ? "Searching..." : "SEARCH"}</Button> </FormItem>
        // }
    }

    renderSearchResults = () => {
        if (this.state.EagleResults.length !== 0) {
            return this.state.EagleResults.map((eagle, i) => {
                // if (i == 0) this.SelectedMemberRecord(eagle, i)
                return (<div className={this.state.memberSelectedKey == i ? 'eagle-results-active' : 'eagle-results'}
                    key={i} onClick={() => this.SelectedMemberRecord(eagle, i)}
                >
                    <Row>
                        <Col xs={23}>
                            <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Scout Name: </b></span><span> {`${eagle.firstName} ${eagle.middleName} ${eagle.lastName}`} </span>
                                </Col>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Member ID: </b></span><span>   {eagle.memberId ? eagle.memberId : '---'}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Board of Review Date:  </b></span><span>  {eagle.eagleBoardReviewDate ? eagle.eagleBoardReviewDate : '---'}</span>
                                </Col>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Awarding Council: </b></span><span>  {eagle.awardingCouncilName ? eagle.awardingCouncilName : '---'} </span>
                                </Col>

                            </Row>
                            <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Council Unit Number: </b></span><span> {eagle.eagleTroopNumber ? eagle.eagleTroopNumber : "---"}</span>
                                </Col>

                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Council City: </b></span><span>  {eagle.eagleCity ? eagle.eagleCity : '---'}</span>
                                </Col>
                            </Row>
                            <Row>

                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Council State: </b></span><span>  {eagle.eagleState ? eagle.eagleState : '---'} </span>
                                </Col>
                            </Row>
                            {/* <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Council State: </b></span><span>  {eagle.eagleState ? eagle.eagleState : '---'} </span>
                                </Col>
                            </Row> */}
                        </Col>
                        {
                            this.state.memberSelectedKey == i ?
                                <Col xs={1}>
                                    <i className="fa fa-check-circle margin-right-10 fa-2x SelectedRecord pointer" aria-hidden="true"></i>
                                </Col> : ''
                        }
                    </Row>
                </div>
                )
            });
        }
    }
    NoResultsMatchMyProfileAlert = () => {
        this.setState({
            NoResultsMatchProfile: true,
            showResultModal: false,
        })
    }

    SelectedMemberRecord = (record, i) => {
        let phoneCountryId = "", PhoneNumber = "";

        if (record.phone.length == 13) {
            let getCountryShort = record.phone.slice(0, 3).toString();
            if (this.props.phonecode) {
                this.props.phonecode.map(code => {
                    if (getCountryShort == code.short) {
                        phoneCountryId = code.id
                    }
                })
            }
            PhoneNumber = record.phone.slice(3);
        } else {
            PhoneNumber = record.phone;
        }

        let getValidEagleDetails = this.getValidEagleStateHandler(record.eagleState, record.eagleCity)

        this.setState({
            phoneCountryId,
            PhoneNumber,
            memberSelectedKey: i,
            selectedRecord: record,
            personGUID: record.personGuid,
            getValidEagleState: getValidEagleDetails.getValidEagleState,
            getValidEagleCity: getValidEagleDetails.getValidEagleCity
        });
    }

    addApprovedRecords = () => {
        let alreadyApproved = this.state.ApprovedRecords
        let ApprovedRecords = alreadyApproved.push(this.state.selectedRecord)
        this.setState({
            showResultModal: false,
            ApprovedRecords: alreadyApproved
        })
    }


    format_Date = (e, field) => {
        let val = e.target.value.split('/');
        let NumExp = /[0-9]/
        val[0] = NumExp.test(val[0]) ? val[0].startsWith('-') ? val[0].replace("-", '0') : val[0] : '';
        val[1] = NumExp.test(val[1]) ? val[1].startsWith('-') ? val[1].replace("-", '0') : val[1] : '';
        val = val.toString().replaceAll(',', '/');
        let hasNumber = /\d/;
        if (field == "DOB" && hasNumber.test(val)) {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    dob: val,
                });
            }, 0)
            this.setState({
                scouts_DOB: val
            })

        } else if (field == "BOR" && hasNumber.test(val)) {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    review_date: val,
                });
            }, 0)
        } else if (field == "scout_dob" && hasNumber.test(val)) {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    scout_dob: val,
                });
            }, 0)
            this.setState({
                scouts_DOB: val
            })
        }
        // else if (field == "C_DATE" && hasNumber.test(val)) {
        //     setTimeout(() => {
        //         this.props.form.setFieldsValue({
        //             certificate_date: val,
        //         });
        //     }, 0)
        // }

    }

    handleSearchSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                //Checking for NESA ineligible applicant
                // if (this.props.profileinfo && this.props.profileinfo.profile && this.props.profileinfo.profile.ineligibleFlag === true){
                //     this.showIneligibleStatusModal();
                // }else{
                    this.props.form.resetFields()
                values.scout_dob = this.state.scouts_DOB
                this.props.actions.searchEagle(values)
                // this.setState({
                //     scouts_DOB: values.scout_dob
                // })
                // }
            }
        })
    }

    handlePromoSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.actions.ApplyPromocode(this.state.membershipRecords, values)
                this.setState({
                    DiscountCode: values.promocode
                })
            }
        })
    }
    handlePromoRemove = () => {
        // e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.actions.RemovePromocode(this.state.membershipRecords, values)
                // this.setState({
                //     DiscountCode: values.promocode
                // })
            }
        })
    }

    renderScoutsInfo = () => {
        if (this.state.selectedRecord) {
            const { getFieldDecorator } = this.props.form;
            let eagleinfo = this.state.selectedRecord

            let ethnicShort = this.state.selectedRecord.ethnicity;
            let ethnicBackground = undefined;
            if (ethnicShort != "" && this.props.ethnicities) {
                this.props.ethnicities.map(each => {
                    if (each.short == ethnicShort) {
                        ethnicBackground = each.name
                    }
                })
            }
            return (<Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                    <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                        <FormItem hasFeedback
                            label="Your First Name"
                        >
                            {getFieldDecorator('firstname', {
                                initialValue: eagleinfo.firstName ? eagleinfo.firstName : '',
                                rules: [{ message: 'Enter Scout\'s First Name!' }],
                            })(
                                <Input disabled placeholder="First Name" className="input-disabled" />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Middle Initial"
                        >
                            {getFieldDecorator('middlename', {
                                initialValue: eagleinfo.middleName ? eagleinfo.middleName : '',
                                rules: [{ message: 'Enter Scout\'s Middle Name!' }],
                            })(
                                <Input disabled placeholder="Middle Name" className="input-disabled" />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Last Name"
                        >
                            {getFieldDecorator('lastname', {
                                initialValue: eagleinfo.lastName ? eagleinfo.lastName : '',
                                rules: [{ min: 2, message: 'Enter Scout\'s Last Name!' }],
                            })(
                                <Input disabled placeholder="Last Name" className="input-disabled" />
                            )}
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Date of Birth"
                            onClick={() => this.setState({ scouts_DOB_MaskChar: '-' })}
                        >
                            {getFieldDecorator('dob', {
                                initialValue: this.state.scouts_DOB ? moment(this.state.scouts_DOB).format('MM/DD/YYYY') : '',
                                rules: [{ message: 'Enter Date of Birth!' }],
                            })(
                                <InputMask
                                    style={{ background: '#f5f5f5 ' }}
                                    className="input-disabled ant-input"
                                    disabled
                                    mask="99/99/9999"
                                    placeholder='MM/DD/YYYY'
                                    alwaysShowMask
                                    maskChar={this.state.scouts_DOB_MaskChar}
                                    onChange={(e) => {
                                        this.format_Date(e, 'DOB')
                                    }}
                                    render={(ref, props) => (
                                        <Input
                                            className="input-disabled" disabled
                                        />
                                    )} />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Member ID"
                        >
                            {getFieldDecorator('memberid', {
                                initialValue: eagleinfo.memberId ? eagleinfo.memberId : '',
                                // rules: [{  min: 2, message: 'Enter Scout\'s Member ID!' }],
                            })(
                                <Input disabled placeholder="Member ID" className="input-disabled" />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem
                            label="Gender"
                        >
                            {getFieldDecorator('gender', {
                                initialValue: eagleinfo.gender ? eagleinfo.gender : '',
                                rules: [{ required: true, message: 'Enter Scout\'s Gender!' }],
                            })(
                                <RadioGroup name="gender" disabled={eagleinfo.gender != '' ? true : false}  >
                                    <Radio value="M">Male</Radio>
                                    <Radio value="F">Female</Radio>
                                </RadioGroup>
                            )}
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                    {/* <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem
                            label="Ethnic Background"
                        >
                            {getFieldDecorator('ethnic', {
                                initialValue: ethnicBackground ? ethnicBackground : '',
                                rules: [{ 
                                    // required: true,
                                     message: 'Enter Scout\'s Ethnic Background!' }],
                            })(
                                <Select style={{ width: '100%' }} disabled={ethnicBackground ? true : false} >
                                    {this.ethnicities()}
                                </Select>
                            )}
                        </FormItem>
                    </Col> */}
                    {/* <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Certificate Date"
                            onClick={() => this.setState({ scouts_DOB_MaskChar: '-' })}
                        >
                            {getFieldDecorator('certificate_date', {
                                initialValue:  '',
                                rules: [{ required: true, message: 'Enter the Certificate Date!' },
                                {
                                  pattern:/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                  message: `Please enter correct format MM/DD/YYYY Pattern`
                               }],
                            })(
                                <InputMask
                                    // style={{ background: '#f5f5f5 ' }}
                                    className="ant-input"
                                    mask="99/99/9999"
                                    placeholder='MM/DD/YYYY'
                                    alwaysShowMask
                                    maskChar={'-'}
                                    onChange={(e) => {
                                        this.format_Date(e, "C_DATE")
                                    }}
                                    render={(ref, props) => (
                                        <Input />
                                    )} />
                            )}
                        </FormItem>
                    </Col> */}
                </Row>
            </Row>)
        }
        else {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Your Personal Information..." />
                </Col>
            </Row>
        }
    }

    render() {
        const { current } = this.state;
        const { minutes, seconds } = this.state
        const { getFieldDecorator } = this.props.form;
        const stateInputEle = () => {
            return (
                <input
                    maxLength={2}
                    style={{ textTransform: "uppercase" }}
                    autoComplete={"off"}
                />
            );
        };
        return (
            <div>
                <NESAHeader />

                <div className='step-widget'>
                    <div className='step-container'>
                        <div className='purchase-membership step-background'>
                            <Row type="flex" align="center" justify="center">
                                <Steps current={current}>
                                    <Step key="eagle-search" title="Eagle Search" />
                                    <Step key="eagle-info" title="Your Info" />
                                    <Step key="payment-Summary" title="Summary" />
                                    <Step key="payment" title="Payment" />
                                    <Step key="receipt" title="Receipt" />
                                </Steps>
                            </Row>
                        </div>
                        <div className="steps-content centered ">
                            {this.state.current == 0 &&
                                <div className="centered" style={{ marginBottom: '40px' }} >
                                    <Form onSubmit={this.handleSearchSubmit} className="search-form alumni-ui">
                                        <Row type="flex" justify="center" align="center">
                                            <Col sm={24} xs={24} lg={24} xl={24} className="center">
                                                <img src="../NESA.png" className='NESA-logo' />
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className='welcome-text'> WELCOME </span>
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className='thank-you'>Thank you for your interest in supporting NESA</span>
                                            </Col>

                                            <Col className="card-margin search-alumni" span={24}>
                                                <Card
                                                    className="centered search-alumni-card"
                                                    title="SCOUT'S PERSONAL INFORMATION"
                                                >
                                                    <Row type='flex' align="middle" gutter={48}>
                                                        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                                            <FormItem
                                                                label="Scout's First Name"
                                                                hasFeedback
                                                            >
                                                                {getFieldDecorator('scout_first_name', {
                                                                    rules: [{ required: true, message: 'Enter Scout\'s First Name!' }],
                                                                })(
                                                                    <Input placeholder="First Name" />
                                                                )}
                                                            </FormItem>
                                                        </Col>
                                                        {/* <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem
                                                                label="Your Middle Initial"
                                                                hasFeedback
                                                            >
                                                                {getFieldDecorator('scout_middle_Initial', {
                                                                    rules: [{ required: false, message: 'Enter Your Middle Initial!' }],
                                                                })(
                                                                    <Input placeholder="Middle Initial" />
                                                                )}
                                                            </FormItem>
                                                        </Col> */}
                                                        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                                            <FormItem
                                                                label="Scout's Last Name"
                                                                hasFeedback
                                                            >
                                                                {getFieldDecorator('scout_last_name', {
                                                                    rules: [{ required: true, message: 'Enter Scout\'s Last Name!' }],
                                                                })(
                                                                    <Input placeholder="Last Name" />
                                                                )}
                                                            </FormItem>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                                            <FormItem
                                                                label="Scout's Date of Birth"
                                                                hasFeedback
                                                                onClick={() => this.setState({ scouts_DOB_MaskChar: '-' })}
                                                            >
                                                                {getFieldDecorator('scout_dob', {
                                                                    initialValue: '',
                                                                    rules: [
                                                                        { required: true, message: 'Enter Scout\'s DOB!' },
                                                                        {
                                                                            pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                                                            message: `Format should be MM/DD/YYYY`
                                                                        }
                                                                    ],
                                                                })(

                                                                    <InputMask
                                                                        mask="99/99/9999"
                                                                        placeholder='MM/DD/YYYY'
                                                                        alwaysShowMask
                                                                        maskChar={this.state.scouts_DOB_MaskChar}
                                                                        className="ant-input"
                                                                        // value={this.state.scouts_DOB}
                                                                        onChange={(e) => {
                                                                            this.format_Date(e, 'scout_dob')
                                                                        }}
                                                                        render={(ref, props) => (
                                                                            <Input

                                                                            />
                                                                        )}
                                                                    />
                                                                )}
                                                            </FormItem>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                                            {this.renderSearchButton()}
                                                        </Col>
                                                        {/* <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem
                                                                label="Your Member ID"
                                                            >
                                                                {getFieldDecorator('scout_member_id', {
                                                                    rules: [{ required: false, message: 'Enter Your Member ID!' }],
                                                                })(
                                                                    <Input placeholder="Member ID" />
                                                                )}
                                                            </FormItem>
                                                        </Col> */}
                                                        {/* <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem
                                                                label="Your Board of Review Date"
                                                            >
                                                                {getFieldDecorator('scout_brd', {
                                                                    rules: [{ required: false, message: 'Enter Your Board of Review Date!' }],
                                                                })(
                                                                    <DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" />
                                                                )}
                                                            </FormItem>
                                                        </Col> */}
                                                    </Row>
                                                </Card>
                                            </Col>
                                        </Row>
                                        {this.state.ApprovedRecords.length >= 1 &&
                                            <Row className='multiple-purchase-table' style={{ display: 'flex', justifyContent: 'center' }}>
                                                <Col className='xs-center sm-center' xs={24} sm={24} md={14} lg={14} xl={18}>
                                                    <Divider orientation="left">Selected NESA members:</Divider>
                                                    <Table
                                                        className=''
                                                        pagination={false}
                                                        columns={columns}
                                                        dataSource={this.state.ApprovedRecords}
                                                        footer={() => <div>
                                                            <Row align="middle" type="flex">
                                                                <Col span={12}>
                                                                    <span>Total Records: {this.state.ApprovedRecords.length}</span>
                                                                </Col>
                                                                <Col span={12}>
                                                                    <Button type="primary" className='right btn-primary' shape="round" size='large' onClick={() => this.next()}>
                                                                        Proceed  <Icon type="right" />
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </div>}
                                                    >

                                                    </Table>
                                                </Col>
                                            </Row>
                                        }
                                    </Form>
                                </div>
                            }
                            {this.state.current == 1 &&
                                <div className="centered steps-form" >
                                    <Form onSubmit={this.handleSubmit} className="purchase-form alumni-ui" style={{ width: '100%' }}>
                                        <Row type="flex" justify="center" align="center">
                                            <Col sm={24} xs={24} lg={24} xl={24} className="center">
                                                <img src="../NESA.png" className='NESA-logo' />
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className='welcome-text'> WELCOME </span>
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className='thank-you'>Thank you for your interest in supporting NESA</span>
                                            </Col>


                                            <Col className="card-margin" span={24}>
                                                <Card className="centered" title="Your Information">
                                                    <Row
                                                        gutter={48}
                                                        style={{ marginLeft: "0px", marginRight: "0px" }}
                                                    >
                                                        <Row
                                                            gutter={24}
                                                            style={{ marginLeft: "0px", marginRight: "0px" }}
                                                        >
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                <FormItem hasFeedback label="First Name">
                                                                    {getFieldDecorator("g_first_name", {
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                message: "Enter First Name!",
                                                                            },
                                                                        ],
                                                                    })(<Input placeholder="First Name" />)}
                                                                </FormItem>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                <FormItem hasFeedback label="Last Name">
                                                                    {getFieldDecorator("g_last_name", {
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                min: 2,
                                                                                message: "Enter Last Name!",
                                                                            },
                                                                        ],
                                                                    })(<Input placeholder="Last Name" />)}
                                                                </FormItem>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                <FormItem hasFeedback label="Phone">
                                                                    {getFieldDecorator("g_phone", {
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                min: 4,
                                                                                max: 10,
                                                                                message: "Enter Scout Phone Number!",
                                                                            },
                                                                            {
                                                                                pattern: new RegExp("^[0-9]*$"),
                                                                                message:
                                                                                    "Phone Number must be all numeric!",
                                                                            },
                                                                        ],
                                                                    })(
                                                                        <Input
                                                                            addonBefore={getFieldDecorator(
                                                                                "g_phonecountryID",
                                                                                {
                                                                                    initialValue: "636",
                                                                                }
                                                                            )(
                                                                                <Select
                                                                                    style={{ width: 100 }}
                                                                                    ref={this.selectphonecountryIDRef}
                                                                                    onSelect={() =>
                                                                                        this.selectphonecountryIDRef.current.blur()
                                                                                    }
                                                                                >
                                                                                    {this.getPhoneCode()}
                                                                                </Select>
                                                                            )}
                                                                            placeholder="Phone"
                                                                        />
                                                                    )}
                                                                </FormItem>
                                                            </Col>
                                                        </Row>
                                                        <Row
                                                            gutter={24}
                                                            style={{ marginLeft: "0px", marginRight: "0px" }}
                                                        >
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                <FormItem hasFeedback label="Email">
                                                                    {getFieldDecorator("g_email", {
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                type: "email",
                                                                                message: "Enter valid email address!",
                                                                            },
                                                                        ],
                                                                    })(<Input placeholder="Email" value="" />)}
                                                                </FormItem>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                <FormItem label="Country">
                                                                    {getFieldDecorator("g_countryId", {
                                                                        initialValue: this.state.yoursCountry
                                                                            ? this.state.yoursCountry
                                                                            : "616",
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                message: "Enter your Country!",
                                                                            },
                                                                        ],
                                                                    })(
                                                                        <Select
                                                                            showAction={["focus", "click"]}
                                                                            showSearch
                                                                            onChange={(e) => {
                                                                                console.log("onBlur " + e);
                                                                                // let getZipCodePattern = zipValidator(e,this.props.countries)
                                                                                this.setState({
                                                                                    yoursCountry: e,
                                                                                    // ZipCodePattern : new RegExp(getZipCodePattern)
                                                                                });
                                                                            }}
                                                                            style={{ width: "100%" }}
                                                                            placeholder="Select a Country"
                                                                            optionFilterProp="children"
                                                                            filterOption={(input, option) =>
                                                                                option.props.children
                                                                                    .toLowerCase()
                                                                                    .indexOf(input.toLowerCase()) >= 0
                                                                            }
                                                                        >
                                                                            {this.countries()}
                                                                        </Select>
                                                                    )}
                                                                </FormItem>
                                                            </Col>
                                                            {this.state.yoursCountry == "616" ||
                                                                this.state.yoursCountry == "" ? (
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                    <FormItem hasFeedback label="Address Line 1">
                                                                        {getFieldDecorator("g_address_line_1", {
                                                                            rules: [
                                                                                {
                                                                                    required: true,
                                                                                    message: "Enter Address!",
                                                                                },
                                                                            ],
                                                                        })(<Input placeholder="Address Line 1" />)}
                                                                    </FormItem>
                                                                </Col>
                                                            ) : (
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                    <FormItem
                                                                        hasFeedback
                                                                        label={
                                                                            <span>
                                                                                Address Line 1&nbsp;
                                                                                <Tooltip
                                                                                    placement="top"
                                                                                    title="Represents street address (2423 Brighton Rd; 17 Downing Street)Combine the normal 2 line address into a single address, separating the house unit from street address via comma (2423 Brighton Road, Apt. 3; 17 Downing Street, Section 7)"
                                                                                >
                                                                                    <Icon type="info-circle-o" />
                                                                                </Tooltip>
                                                                            </span>
                                                                        }
                                                                    >
                                                                        {getFieldDecorator("g_address_line_1", {
                                                                            rules: [
                                                                                {
                                                                                    required: true,
                                                                                    message: "Enter Address!",
                                                                                },
                                                                            ],
                                                                        })(<Input placeholder="Address Line 1" />)}
                                                                    </FormItem>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                        <Row
                                                            gutter={24}
                                                            style={{ marginLeft: "0px", marginRight: "0px" }}
                                                        >
                                                            {this.state.yoursCountry == "616" ||
                                                                this.state.yoursCountry == "" ? (
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                    <FormItem hasFeedback label="Address Line 2">
                                                                        {getFieldDecorator("g_address_line_2", {
                                                                            rules: [
                                                                                {
                                                                                    required: false,
                                                                                    message: "Enter Address!",
                                                                                },
                                                                            ],
                                                                        })(<Input placeholder="Address Line 2" />)}
                                                                    </FormItem>
                                                                </Col>
                                                            ) : (
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                    <FormItem
                                                                        hasFeedback
                                                                        style={{ marginBottom: "0px" }}
                                                                        label={
                                                                            <span>
                                                                                Address Line 2&nbsp;
                                                                                <Tooltip
                                                                                    placement="top"
                                                                                    title="Represents a unit, number or subset of the street address (Apt. 12; Section 3; Dept. 22)"
                                                                                >
                                                                                    <Icon type="info-circle-o" />
                                                                                </Tooltip>
                                                                            </span>
                                                                        }
                                                                    //extra="City, Territory, Postal Code, Country"
                                                                    >
                                                                        {getFieldDecorator("g_address_line_2", {
                                                                            rules: [
                                                                                {
                                                                                    required: false,
                                                                                    message: "Enter Address!",
                                                                                },
                                                                            ],
                                                                        })(<Input placeholder="Address Line 2" />)}
                                                                    </FormItem>
                                                                </Col>
                                                            )}
                                                            {this.state.yoursCountry == "616" ||
                                                                this.state.yoursCountry == "" ? (
                                                                <span>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem hasFeedback label="City">
                                                                            {getFieldDecorator("g_city", {
                                                                                rules: [
                                                                                    {
                                                                                        required: true,
                                                                                        min: 2,
                                                                                        message: "Enter City!",
                                                                                    },
                                                                                ],
                                                                            })(<Input placeholder="City" />)}
                                                                        </FormItem>
                                                                    </Col>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem hasFeedback label="State">
                                                                            {getFieldDecorator("g_state", {
                                                                                rules: [
                                                                                    {
                                                                                        required: true,
                                                                                        message: "Enter State!",
                                                                                    },
                                                                                ],
                                                                            })(
                                                                                <Select
                                                                                    getInputElement={stateInputEle}
                                                                                    showAction={["focus", "click"]}
                                                                                    showSearch
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        textTransform: "uppercase",
                                                                                    }}
                                                                                    placeholder="Select a State"
                                                                                    optionFilterProp="children"
                                                                                    filterOption={(input, option) =>
                                                                                        option.props.children
                                                                                            .toLowerCase()
                                                                                            .indexOf(input.toLowerCase()) >= 0
                                                                                    }
                                                                                >
                                                                                    {this.statesID()}
                                                                                </Select>
                                                                            )}
                                                                        </FormItem>
                                                                    </Col>
                                                                </span>
                                                            ) : (
                                                                <span>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem
                                                                            hasFeedback
                                                                            style={{ marginBottom: "0px" }}
                                                                            label={
                                                                                <span>
                                                                                    Address Line 3&nbsp;
                                                                                    <Tooltip
                                                                                        placement="top"
                                                                                        title="List the city, territory, postal code and country according to country standards (Southampton, SO53 5PD, UK; Vancouver, BC V5X 2H6"
                                                                                    >
                                                                                        <Icon type="info-circle-o" />
                                                                                    </Tooltip>
                                                                                </span>
                                                                            }
                                                                            extra="City, Territory, Postal Code, Country"
                                                                        >
                                                                            {getFieldDecorator("g_address_line_3", {
                                                                                rules: [
                                                                                    {
                                                                                        required: true,
                                                                                        message: "Enter Address!",
                                                                                    },
                                                                                ],
                                                                            })(
                                                                                <Input placeholder="Address Line 3" />
                                                                            )}
                                                                        </FormItem>
                                                                    </Col>
                                                                </span>
                                                            )}
                                                            {this.state.yoursCountry == "616" ||
                                                                (this.state.yoursCountry == "" && (
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem hasFeedback label="ZIP Code">
                                                                            {getFieldDecorator("g_zip_code", {
                                                                                rules: [
                                                                                    {
                                                                                        required: true,
                                                                                        // pattern: this.state.ZipCodePattern ,
                                                                                        message: "Enter ZIP Code!",
                                                                                    },
                                                                                ],
                                                                            })(
                                                                                <InputMask
                                                                                    // mask="******" // (alpha/ numeric)
                                                                                    // mask="99999" // (numeric)
                                                                                    placeholderChar=""
                                                                                    className="ant-input"
                                                                                    render={(ref, props) => (
                                                                                        <Input placeholder="ZIP Code" />
                                                                                    )}
                                                                                />
                                                                            )}
                                                                        </FormItem>
                                                                    </Col>
                                                                ))}
                                                        </Row>
                                                        {this.state.yoursCountry == "616" ||
                                                            this.state.yoursCountry == "" ? (
                                                            <Row
                                                                gutter={24}
                                                                style={{
                                                                    marginLeft: "0px",
                                                                    marginRight: "0px",
                                                                }}
                                                            >
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                    <FormItem hasFeedback label="ZIP Code">
                                                                        {getFieldDecorator("g_zip_code", {
                                                                            rules: [
                                                                                {
                                                                                    required: true,
                                                                                    max: 5,
                                                                                    min: 5,
                                                                                    message: "Enter ZIP Code!",
                                                                                },
                                                                            ],
                                                                        })(
                                                                            <InputMask
                                                                                // mask="*** ***" // (alpha/ numeric)
                                                                                mask="99999" // (alpha/ numeric)
                                                                                placeholderChar=""
                                                                                className="ant-input"
                                                                                render={(ref, props) => (
                                                                                    <Input placeholder="ZIP Code" />
                                                                                )}
                                                                            />
                                                                        )}
                                                                    </FormItem>
                                                                </Col>
                                                            </Row>
                                                        ) : null}
                                                    </Row>
                                                </Card>
                                            </Col>
                                            {/* <Col className="card-margin" span={24}>
                                                <Card
                                                    className="centered"
                                                    title="Shipping Information"
                                                >
                                                    <Row>
                                                        <Col>
                                                            <FormItem hasFeedback
                                                                label="Type of Delivery"
                                                            >
                                                                {getFieldDecorator('shipping', {
                                                                    rules: [{ required: true, message: 'Choose Shippping Address!' }],
                                                                })(
                                                                    <RadioGroup onChange={this.ChangeShippingAddress} value={this.state.shippingAddress}>
                                                                        <Radio value={1}>Email</Radio>
                                                                        <Radio value={2}>Home Mailing Address</Radio>
                                                                    </RadioGroup>
                                                                )}
                                                            </FormItem>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col> */}
                                            <Col className="card-margin" span={24}>
                                                <Card
                                                    className="centered"
                                                    title="Membership Transaction Fee"
                                                >
                                                    <Row>
                                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                            <div className="Summary-title-txt" style={{ fontSize: '14px' }}>
                                                                Optional Transaction Fee &nbsp;
                                    <Tooltip placement="bottom" title="Please consider covering the transaction fees for this membership purchase">
                                                                    <Icon type="info-circle-o" theme="twoTone" />
                                                                </Tooltip>
                                                            </div>
                                                            {/* <div className="summary-label-txt" style={{ fontSize: '14px' }} ></div> */}
                                                        </Col>

                                                        <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                                            <div className="summary-label-txt">
                                                                <Switch checked={this.state.isPayTransactionFees} onChange={() => this.calculateFee()} />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row >
                                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                            <div className="summary-label-txt" style={{ fontSize: '14px' }} >Transaction Fees</div>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                                            <div className="summary-label-txt">$ {this.state.transactionFee} </div>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>

                                            <div className="steps-action centered" style={{ width: '100%' }}>
                                                <Row type="flex" justify="space-between" style={{ position: "unset" }}>
                                                    <Col xs={24} sm={24} md={9} lg={7} xl={7}  >
                                                        <div className="text-result pointer"
                                                            style={{ marginTop: "55px", marginBottom: '55px' }}
                                                            onClick={() => {
                                                                // let total = (Math.round((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * 100) / 100).toFixed(2);
                                                                // this.setState({
                                                                //     current: 0,
                                                                //     isPayTransactionFees: false,
                                                                //     TotalAmount: total
                                                                // })
                                                                // history.push('/purchasee-membership')
                                                                this.prev()
                                                            }}><i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i> Back to Eagle Search</div>
                                                    </Col>
                                                    <Col className='xs-center sm-center' xs={24} sm={24} md={7} lg={7} xl={7} offset={1}>
                                                        <FormItem>
                                                            {this.renderPaymentButton()}
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                            </div>


                                        </Row>

                                    </Form>
                                </div>

                            }
                            {this.state.current == 2 &&
                                this.renderPaymentSummary()
                            }
                            {this.state.current == 3 &&
                                <div>
                                    <div className="centered steps-payment">
                                        <Row className='margin-top-30' gutter={48} type="flex" justify="space-between" align="center">
                                            <Col xs={24} sm={24} md={24} lg={16} className="">
                                                <Card
                                                    className="margin-top-30"
                                                    title="Payment Information"

                                                >
                                                    <Row>
                                                        <Col span={10}>
                                                            <div className="checkbox-card-icon-wrapper">
                                                                <Row>
                                                                    <Col span={10}>
                                                                        <div className="title-txt margin-top-10" style={{ fontSize: '16px' }}>Credit Card</div>
                                                                    </Col>
                                                                    <Col span={10}>
                                                                        <img src='../credit-card.png' height={40} />
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Spin tip={`Please do not close the browser until the Receipt is displayed! \n  Redirecting in ${seconds} seconds...`} style={{ whiteSpace: "break-spaces" }} spinning={this.state.receipt_loading}>
                                                        {this.renderIframe()}
                                                    </Spin>
                                                </Card>
                                            </Col>

                                            <Col xs={24} sm={24} md={24} lg={8} className="">
                                                <Card
                                                    className="margin-top-30"
                                                    title="Summary"

                                                >
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={12}>
                                                            <span className="title-txt" style={{ fontSize: '16px' }}>Eagle Info</span>
                                                        </Col>
                                                        <Col span={12} className="right">
                                                            <span className="verified"><Icon type="check-circle" /> Verified</span>
                                                        </Col>
                                                        <Col span={24}>
                                                            <span className="label-txt" style={{ fontSize: '14px' }} >{this.state.firstname} {this.state.middlename} {this.state.lastname} </span>
                                                        </Col>
                                                        <Col span={24}>
                                                            <span className="label-txt" style={{ fontSize: '14px' }} >{this.state.memberId} </span>
                                                        </Col>
                                                    </Row>
                                                    <hr />
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={24}>
                                                            <span className="title-txt" style={{ fontSize: '16px' }}>Level</span>
                                                        </Col>

                                                        <Col span={18}>
                                                            <span className="label-txt" style={{ fontSize: '14px' }} ><span className="label-txt" style={{ fontSize: '14px' }} >{ `${this.state.SelectedMembershipName} (with New Eagle Discount)` }</span>
                                                            </span>
                                                        </Col>
                                                        <Col span={6} className="right">
                                                            <span className="summary-price" style={{ fontSize: '14px' }}>$ {this.state.SelectedMembershipPrice}</span>
                                                        </Col>

                                                        {this.state.PromocodeApplied && <Row type="flex" justify="space-between" align="center" style={{ width: '100%' }}>
                                                            <Col span={18}>
                                                                <span className="label-txt green-txt" style={{ fontSize: '14px' }} ><CheckCircleTwoTone twoToneColor="#52c41a" /> {this.state.DiscountCode}</span>
                                                            </Col>
                                                            <Col span={6} className="right">
                                                                <span className="summary-price green-txt" style={{ fontSize: '14px' }}>-$ {this.state.DiscountAmount}</span>
                                                            </Col>
                                                        </Row>}

                                                        {this.state.PromocodeApplied && <Row style={{ width: '100%' }}>
                                                            <Col span={18}>
                                                                <div className="summary-label-txt" style={{ fontSize: '14px' }} >Membership Cost</div>
                                                            </Col>

                                                            <Col span={6} className="right">
                                                                <div className="summary-label-txt">${parseFloat(parseFloat(this.state.SelectedMembershipPrice) - parseFloat(this.state.DiscountAmount)).toFixed(2)}</div>
                                                            </Col>
                                                        </Row>}
                                                        {this.state.PromocodeApplied &&
                                                            <Divider style={{ margin: '10px 0px' }} />}

                                                        <Col span={18}>
                                                            <span className="label-txt" style={{ fontSize: '14px' }} >{this.state.SelectedMembershipName} S/H</span>
                                                        </Col>
                                                        <Col span={6} className="right">
                                                            <span className="summary-price" style={{ fontSize: '14px' }}>$ {this.state.shipping_handlingCharge}</span>
                                                        </Col>

                                                    </Row>
                                                    {this.state.isPayTransactionFees && <Row type="flex" justify="space-between" align="center">
                                                        <Col span={18}>
                                                            <span className="label-txt" style={{ fontSize: '14px' }} >Transaction Fees</span>
                                                        </Col>
                                                        <Col span={6} className="right">
                                                            <span className="summary-price" style={{ fontSize: '14px' }}>$ {this.state.transactionFee}</span>
                                                        </Col>
                                                    </Row>}

                                                    <hr />
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={12}>
                                                            <span className="title-txt" style={{ fontSize: '16px' }}>Total</span>
                                                        </Col>
                                                        <Col span={12}>
                                                            <span className="price-txt" style={{ fontSize: '14px' }}>${this.state.TotalAmount}</span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col className='xs-center sm-center' xs={24} sm={24} md={12} lg={12} xl={12}>
                                                <div className="steps-action centered">
                                                    <div className="text-result pointer"
                                                        style={{ marginTop: "55px", marginBottom: '55px' }}
                                                        onClick={() => {
                                                            // let total = (Math.round((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * 100) / 100).toFixed(2);
                                                            // this.setState({
                                                            //     ShowPaymentSummary: true,
                                                            //     isPayTransactionFees: false,
                                                            //     TotalAmount: total
                                                            // })
                                                            this.prev()

                                                        }}>
                                                        <i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i> Back to Eagle Summary</div>
                                                </div>
                                                {/* <Button type="primary" className='back-btn' onClick={() => this.prev()}>Back to Step 2</Button> */}
                                            </Col>

                                        </Row>
                                    </div>
                                    {this.renderReceiptpage()}
                                </div>
                            }
                            {this.state.current == 4 &&
                                <div>
                                    <div className="centered steps-receipt">
                                        <Row gutter={48} type="flex">
                                            <Col xs={24} sm={24} md={8} lg={8} className="margin-top-30">
                                                <Card
                                                    className=""
                                                >
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={24}>
                                                            <span className="title-txt">Summary</span>
                                                        </Col>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-high-txt">Name</span>
                                                            <span className="label-txt">{this.state.firstname} {this.state.middlename} {this.state.lastname}</span>
                                                        </Col>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-high-txt">Date</span>
                                                            <span className="label-txt">{moment().format('MM/DD/YYYY')}</span>
                                                        </Col>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-high-txt">Address</span>
                                                            <span className="label-txt">
                                                                {this.state.address1} <br />
                                                                {this.state.address2} <br />
                                                                {this.state.city}, {this.state.userDetails.stateName} <br />
                                                                {this.state.zip} <br />
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                    <hr />
                                                    <Row>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-txt"><b>{this.state.SelectedMembershipName}</b></span>
                                                        </Col>
                                                        <Col span={12} className=''>
                                                            <span className="title-txt">Total</span>
                                                        </Col>
                                                        <Col span={12} className='right'>
                                                            <span className="summary-price"><b>${this.state.TotalAmount}</b></span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col xs={24} sm={24} md={14} lg={14} className="margin-top-30">
                                                <Card
                                                    className="receipt-header"
                                                    title="National Eagle Scout Association"
                                                >
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={24} className='right'>
                                                            <img src="../NESA.png" className='receipt-logo' />
                                                        </Col>
                                                        <Col>

                                                            <p>{this.state.ReceiptPara1}</p>

                                                            <p> The National Eagle Scout Association is a fellowship of individuals who have achieved the Eagle Scout rank. Only 5 percent of Scouts ever reach this goal. Former Secretary of Defense Robert M. Gates and astronaut James A. Lovell Jr. are two of NESA's more than 180,000 members.
                                                                Only those who have been granted the Eagle Scout Award by, and are eligible to participate in programs offered by, the Scouting America may hold membership in the National Eagle Scout Association. Applications for NESA membership are cross-checked against the National Eagle Scout register maintained by the National Eagle Scout Association.</p>

                                                            <p> The Scouting America thanks you for your continued commitment to Scouting.</p>

                                                            <p>If you have any questions about membership, Please contact NESA at the following email address: <a href="mailto:NESA@scouting.org">NESA@scouting.org</a></p>

                                                        </Col>
                                                        <Col span={24} className="right signature-block">
                                                            <span>Yours in Scouting</span>
                                                            <img src='JohnStachniak_Signature.jpg' className='director-logo' />
                                                            <span><b>John Stachniak</b></span>
                                                            <span>Director, National Eagle Scout Association</span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col xs={24} sm={24} md={14} lg={14}>
                                                <Button type="primary" className='submit-btn' onClick={() => window.location.assign('https://nesa.org/')}>GO HOME</Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="steps-action centered">
                            {
                                this.state.current == 0
                                && <div className='membership-bottom'></div>
                            }
                        </div>
                    </div>
                </div>
                <NESAFooter />

                <Modal
                    className='multiple-r-modal'
                    title={false}
                    footer={false}
                    visible={this.state.showResultModal}
                    centered
                    onCancel={() => this.closeResult()}
                >
                    <div>
                        <span className='modal-header'>Search Results</span>
                        <span className='modal-desc'>Please select the records to gift the NESA membership.</span>
                    </div>

                    {this.renderSearchResults()}

                    <Row type='flex' align="middle" justify="space-around">
                        <Col className='xs-center sm-center' xs={24} sm={24} md={24} lg={5} xl={5} >
                            <div className='step-container margin-top-20' >
                                <Button size='large' className='width-100' type="danger" ghost onClick={() => this.NoResultsMatchMyProfileAlert()}>NOT MATCH</Button>
                            </div>
                        </Col>
                        <Col className='xs-center sm-center' xs={24} sm={24} md={24} lg={5} xl={5} offset={2}>
                            <div className='step-container margin-top-20' >
                                <Button size='large' className='width-100 ' onClick={() => this.closeResult()}>CANCEL</Button>
                            </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5} offset={2}>
                            <div className='step-container margin-top-20' >
                                <Button type="primary" className='width-100 ' size='large' onClick={() => this.addApprovedRecords()} htmlType='submit'>SELECT</Button>
                            </div>
                        </Col>
                    </Row>
                </Modal>
                <Modal
                    className='No-records-match-myMrofile-model'
                    title={false}
                    footer={false}
                    visible={this.state.NoResultsMatchProfile}
                    centered
                    onCancel={() => this.closeNorecordsMatchProfile()}
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>
                        <div className='No-Results-Match-Pro'>
                            No Results Match Profile
                        </div>

                        <div className='margin-bottom-20'> Whoops! It appears no current Eagle Scout record matches your Eagle Scout information. Please confirm the Eagle Scout MemberID and try again.</div>
                        <div>Alternatively, please contact the Scout's Eagle Scout council for further assistance.</div>

                        <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                                <div className='step-container margin-top-20' >
                                    <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                        this.closeNorecordsMatchProfile();
                                    }} htmlType='submit'>CLOSE </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Modal>
                <Modal
                    className='No-records-Found-model'
                    style={{ width: '600px' }}
                    title={false}
                    footer={false}
                    visible={this.state.NoResultsFound}
                    centered
                    onCancel={() => this.close_NoResultsFound_Modal()}
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>
                        <div className='No-Results-Match-Pro'>
                            No Eagle Scout Record found!
                        </div>

                        {/* <div className='margin-bottom-20'> Whoops! We found the Scout but there wasn't any Eagle Scout information associated with them.  Please confirm the Eagle Scout MemberID and try again.</div>
                        <div>Alternatively, please contact the Eagle Scout council for further assistance.</div> */}

                        <div className='margin-bottom-20'> Whoops! it appears there is critical information regarding First Name, Last Name or Date of Birth, missing from your Eagle Scout record. </div>
                        {/* <div style={{color: ' #cc0033', marginBottom: '10px'}}>
                            Firstname, Lastname, Date of Birth
                        </div>
                        <div> please contact your Eagle Scout council for further assistance.</div>
                        <div style={{backgroundColor: "#fce4e4", border: '2px solid #fcc2c3', padding: '10px 20px', margin: '10px 0px', color: ' #cc0033'}}>
                            Missing or incomplete ID records in Akela (the master membership database)
                        </div> */}

                        {/* <div> Note: The missing information would identify the missing or incomplete information needed to complete a NESA application </div>  */}
                        <div> Please contact your Eagle Scout council to update your Eagle information. </div>

                        <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                                <div className='step-container margin-top-20' >
                                    <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                        this.close_NoResultsFound_Modal();
                                    }} htmlType='submit'>CLOSE </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Modal>
                <Modal
                    centered
                    className='IneligibleApplicantModal'
                    visible={this.state.ShowIneligibleStatus}
                    onCancel={this.closeIneligibleStatusModal}
                    title="Whoops!"
                    footer={
                        <Button key="submit" type="primary" className="RedirectIneligibleToNESA"
                            onClick={this.CloseIneligibleToDashboard}>
                            Close
                        </Button>
                    }
                >
                    It appears there is a question of your NESA membership eligibility.
                    Please contact your local council for more detailed information.
                </Modal>
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        loggingIn: state.authenticationReducer.loggingIn,
        timeout: state.authenticationReducer.timeout,
        initloading: state.chasepaymentreducer.loading,
        initTransaction: state.chasepaymentreducer.initTransaction,
        ethnicities_loading: state.ethnicitiesreducer.loading,
        ethnicities: state.ethnicitiesreducer.ethnicities,
        // profileloading: state.profilereducer.loading,
        // profileinfo: state.profilereducer.profileinfo,
        paymentstatus: state.paymentcompletedreducer.status,
        productprice: state.productpricereducer.productprice,
        productprice_loading: state.productpricereducer.loading,
        nesa_levels_loading: state.nesalevelsreducer.loading,
        nesa_levels: state.nesalevelsreducer.levels,
        allstates: state.allstatesreducer.states,
        // eagleinfo: state.eagleinforeducer.eagleinfo,
        // eagleinfo_loading: state.eagleinforeducer.loading,
        loading: state.purchasemembershipreducer.loading,
        response: state.purchasemembershipreducer.response,
        regstatus: state.regstatusreducer.status,
        searching: state.eagleSearchReducer.searching,
        searchedEagle: state.eagleSearchReducer.eagle,
        // alumnieagleinfo: state.alumnieagleinforeducer.eagleinfo,
        // alumnieagleinfo_loading: state.alumnieagleinforeducer.loading,
        countries: state.countriesreducer.countries,
        phonecode: state.phonecountrycodereducer.code,
        registration_loading: state.purchasemembershipreducer.loading,
        applingPromocode: state.promocodereducer.loading,
        PromocodeAdded: state.promocodereducer.response,
        promoCode: state.promocodereducer.promoCode,
        PromocodeRemoved: state.promocodereducer.removedPromoAmount,
        PromocodeError: state.promocodereducer.error,
        creatingPayments: state.PaymentsCreateReducer.loading,
        createdPayments: state.PaymentsCreateReducer.response,
        regError: state.regstatusreducer.regError,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) }
}

const MultipleMembership = Form.create()(MulipleMembershipForm);

export default connect(mapStateToProps, mapDispatchToProps)(MultipleMembership);


// WEBPACK FOOTER //
// ./src/components/Membership/MultipleMembership.js